import { axiosInstance } from "../index";

const addArrayOfFlashCards = async (params) => {
  return await axiosInstance.post(`/flashcards/bulk_create`, params);
};

const addSingleFlashCard = async (params) => {
  return await axiosInstance.post(`/flashcards`, params);
};

const getAllFlashcards = async (params) =>
  await axiosInstance.get("/flashcards", { params });

const getSingleFlashcard = async ({ id }) =>
  await axiosInstance.get(`/flashcards/${id}`);

const editSingleFlashcard = async ({ flashcard, id }) =>
  await axiosInstance.patch(`/flashcards/${id}`, flashcard);
const deleteSingleFlashcard = async ({ id }) =>
  await axiosInstance.delete(`/flashcards/${id}`);

export {
  addArrayOfFlashCards,
  addSingleFlashCard,
  getAllFlashcards,
  getSingleFlashcard,
  editSingleFlashcard,
  deleteSingleFlashcard
};
